import React from 'react';
import useLibraryController from './controller/use-library-controller';
import LibraryView from './view/LibraryView';
import decodeToken from '../../../../utils/decode-token';
import {
  canPublishLibraryToPre,
  canPublishLibraryToPro,
  canSeeReports,
  canUploadLibraryFile,
} from '../../../../utils/role-utils';

const Library = () => {
  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;
  const canSeePublishPro = canPublishLibraryToPro(role);
  const isProPublishingEnabled = process.env.REACT_APP_ENABLE_PRO_PUBLISH === 'true';
  const canPublishPro = isProPublishingEnabled && canSeePublishPro;
  const controller = useLibraryController({ canPublishPro });

  return (
    <LibraryView
      activeTab={controller.activeTab}
      onTabChange={controller.setActiveTab}
      search={controller.search}
      onSearchChange={controller.setSearch}
      statusFilter={controller.statusFilter}
      onStatusFilterChange={controller.setStatusFilter}
      countryFilter={controller.countryFilter}
      onCountryFilterChange={controller.setCountryFilter}
      countryFilterOptions={controller.countryFilterOptions}
      typeFilter={controller.typeFilter}
      onTypeFilterChange={controller.setTypeFilter}
      rows={controller.rows}
      isLoading={controller.isLoading}
      onOpenAddModal={controller.openAddModal}
      onDeployPre={controller.deployToPre}
      onDeployPro={controller.requestDeployToPro}
      onDownload={controller.handleDownload}
      onDelete={controller.requestDeleteFile}
      successMessage={controller.successMessage}
      errorMessage={controller.errorMessage}
      onCloseSuccessMessage={controller.clearSuccessMessage}
      onCloseErrorMessage={controller.clearErrorMessage}
      isAddModalOpen={controller.isAddModalOpen}
      onCloseAddModal={controller.closeAddModal}
      form={controller.form}
      countryOptions={controller.countryOptions}
      languageOptions={controller.languageOptions}
      typeOptions={controller.typeOptions}
      onUpdateForm={controller.updateFormField}
      onUpload={controller.handleUpload}
      isSubmitting={controller.isSubmitting}
      isUploadDisabled={controller.isUploadDisabled}
      formError={controller.formError}
      pendingProFile={controller.pendingProFile}
      isPublishingPro={controller.isPublishingPro}
      deployProError={controller.deployProError}
      onClearDeployProError={controller.clearDeployProError}
      onCancelDeployPro={controller.cancelDeployToPro}
      onConfirmDeployPro={controller.confirmDeployToPro}
      pendingDeleteFile={controller.pendingDeleteFile}
      onCancelDelete={controller.cancelDeleteFile}
      onConfirmDelete={controller.confirmDeleteFile}
      canPublishPre={canPublishLibraryToPre(role)}
      canSeePublishPro={canSeePublishPro}
      canPublishPro={canPublishPro}
      canUploadFile={canUploadLibraryFile(role)}
      canDeleteFile={canUploadLibraryFile(role)}
      canViewReports={canSeeReports(role)}
      canUploadMasterEnglish={role === 'admin'}
      onPreviewAs={controller.handlePreviewAs}
    />
  );
};

export default Library;
